export const encodeObjectValues = (obj) => {

    if (typeof obj === 'string') {
        if (/@/.test(obj)) {
            const encodedData = encodeURIComponent(obj);
            const retainEmailData = encodedData?.replace(/%40/g, '@');
            return retainEmailData;
        }
        else if (/\+/.test(obj)) {
            const retainSpace = obj?.replace(/\+/g, ' ');
            const encodedData = encodeURIComponent(retainSpace);
            return encodedData;
        }
        else {
            return encodeURIComponent(obj);
        }
    }
    else if (Array.isArray(obj)) {
        return obj.map(encodeObjectValues);
    }
    else if (typeof obj === 'object' && obj !== null) {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, encodeObjectValues(value)])
        );
    }
    return obj;
}

export const decodeObjectValues = (obj) => {

    if (typeof obj === 'string') {
        if (/\+/.test(obj)) {
            const retainSpace = obj?.replace(/\+/g, '%20');
            const encodedData = decodeURIComponent(retainSpace);
            return encodedData;
        }
        else {
            return decodeURIComponent(obj);
        }
    }
    else if (Array.isArray(obj)) {
        return obj.map(decodeObjectValues);
    }
    else if (typeof obj === 'object' && obj !== null) {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, decodeObjectValues(value)])
        );
    }
    return obj;
}

export const encodeArrayOfObjects = (array) => {
    if (!Array.isArray(array)) {
        return null;
    }

    return array.map((obj) => {
        if (typeof obj !== 'object' || obj === null) {
            return null;
        }

        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => {
                if (typeof value === 'string') {
                    return [key, encodeURIComponent(value)];
                } else if (typeof value === 'object' && value !== null) {
                    return [key, encodeObjectValues(value)];
                }
                return [key, value];
            })
        );
    });
}

export const removeEmptyKeys = (obj) => {
    if (obj) {
        const keys = Object.keys(obj)?.filter((key) => obj[key] === null || obj[key] === undefined || obj[key] === "" || obj[key] === '');
        keys.forEach((key) => {
            delete obj[key];
        })
        return obj;
    }
}

export const removeEmptyKeysArray = (array) => {
    if (array?.length > 0) {
        const filteredArray = array?.map((obj) => {
            return removeEmptyKeys(obj);
        })
        const nonEmptyObjArr = filteredArray?.filter((obj) => !((obj === undefined) || (obj === null) || (Object.keys(obj).length === 0)));
        return nonEmptyObjArr
    }
}
